export default "__VITE_ASSET__BUcxSI6n__"